module.exports = "<div *ngIf=\"tab=== EfficiencyDetails.REDY_TIPS\">\r\n    <app-redy-tips></app-redy-tips>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/efficiency/efficiency-tab/efficiency-tab.component.html
// module id = ./src/app/entities/efficiency/efficiency-tab/efficiency-tab.component.html
// module chunks = main